import apiCall from '@/utils/api'

const state = {
  login: false,
  balance: 0,
  name: '',
  id: 0
}

const actions = {
  getProfile: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      apiCall({controller: 'Account', method: 'GET'})
        .then(resp => {
          console.log(resp.data.response[0])
          commit('setProfile', resp.data.response[0])
        })
        .catch(err => {
          console.log(err)
        })
      resolve()
    })
  }
}

const getters = {
  getBalance: state => state.balance,
  getName: state => state.name
}

const mutations = {
  setBalance (state, newbalance) {
    state.balance = newbalance
  },
  setProfile: (state, profile) => {
    state.login = true
    state.balance = profile.balance
    state.name = profile.name
    state.id = profile.id
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js